module.exports = __webpack_public_path__ + "img/sand-decal-05.572dca45.png";